export default function AlertMessage({ message, onClose }) {
  if (!message) return null;

  const variant = message.tipo || message.type || "info";
  const text = message.texto || message.text || message;

  return (
    <div className={`alert alert-${variant} alert-dismissible fade show`} role="alert">
      {text}
      {onClose && (
        <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose}></button>
      )}
    </div>
  );
}
